import { DetailPageActions, DetailPageActionTypes } from '../actions';
import { Reducer } from 'redux';

export type PageTitleId = string

export const initialState = ''

export const reducer: Reducer<PageTitleId, DetailPageActions> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case DetailPageActionTypes.STORE_MERGE:
            return action.payload && action.payload.pageTitleId || state
        case DetailPageActionTypes.CHANGE_PAGE:
            return action.payload.pageTitleId
        default:
            return state
    }
}
